<template>
  <div
    :id="'details-trip' + tripNumber"
    :class="'details-trip text-left' + tripNumber"
  >
    <h6 class="text-center"><b>Details</b></h6>
    <hr />

    <div class="details-trip__data">
      <span class="details-trip__data--element"
        ><b>Miles: </b><span v-if="miles != null">{{ miles }}</span></span
      >
      <span class="details-trip__data--element"
        ><b>Tolls: </b><span v-if="tolls != null">{{ tolls }}</span></span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DetailsTrip",
  props: {
    tripNumber: Number
  },
  data() {
    return {
      miles: null,
      tolls: null,
      user: null,
      quoteById: null,
      oldValueAux: null,
      newValueAux: null,
      allowed: true,
      currentDepartment: null
    };
  },
  computed: {
    ...mapGetters("coordinatesMap", ["showInfoPcmiler"]),
    ...mapGetters("login", ["showInfoDepartment"])
  },
  watch: {
    async showInfoPcmiler(value) {
      let infoPcmiler = value;
      this.miles = infoPcmiler.miles;
      this.tolls = infoPcmiler.tolls;
    },

    async showInfoDepartment(value) {
      this.currentDepartment = value;
    }
  },
  async created() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters["quotes/quote/showQuoteById"],
      (newValue, oldValue) => {
        this.oldValueAux = oldValue;
        this.newValueAux = newValue;
        // this.assignMode();
        this.asignMilesAndTolls();
      }
    );
  },
  beforeMount() {
    this.asignMilesAndTolls();
  },
  mounted() {
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    let allowedRoutes = ["ftlqueue", "myQueue", "failed"];
    if (!allowedRoutes.includes(this.$route.params.pathName)) {
      this.allowed = false;
    }
    this.currentDepartment = this.showInfoDepartment;
    if (this.currentDepartment.rol_name == "superuser" || !this.allowed) {
      document.getElementById(
        `details-trip` + this.tripNumber
      ).style.pointerEvents = "none";
    }
  },
  methods: {
    async asignMilesAndTolls() {
      this.quoteById = await this.$store.getters["quotes/quote/showQuoteById"];
      if (
        this.quoteById.haul[this.tripNumber - 1] &&
        this.quoteById.haul[this.tripNumber - 1].pcmiler != null &&
        this.quoteById.haul[this.tripNumber - 1].pcmiler != ""
      ) {
        let pcMilerCalculate = this.$store.getters["quotes/quote/showQuoteById"]
          .haul[this.tripNumber - 1].pcmiler;
        this.miles = pcMilerCalculate.miles;
        this.tolls = pcMilerCalculate.tolls;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.details-trip {
  @include card;
  height: 100%;
  width: fit-content;
  hr {
    @include margin-card-hr;
  }
  &__data {
    @include flex-wrap(space-around);
    &--element {
      margin-top: 5px;
      width: 180px;
    }
  }
}

@media (max-width: 767px) {
  .details-trip {
    margin-top: 15px;
  }
}
</style>
